import type { ReactNode } from "react";
import { Topbar } from "@features/navigation/components/topbar";
import { SettingSidebar } from "./setting-sidebar";

export function SettingLayout({
  activeMenuId,
  children,
}: {
  activeMenuId: string;
  children: ReactNode;
}) {
  return (
    <>
      <Topbar active="setting" />
      <div className="layout">
        <SettingSidebar activeMenuId={activeMenuId} />
        <main className="content" id="content">
          {children}
        </main>
      </div>
    </>
  );
}
